import { render } from "./choose-activeity.vue?vue&type=template&id=d87c5288&scoped=true&ts=true"
import script from "./choose-activeity.vue?vue&type=script&lang=ts"
export * from "./choose-activeity.vue?vue&type=script&lang=ts"

import "./choose-activeity.vue?vue&type=style&index=0&id=d87c5288&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d87c5288"]])

export default __exports__